<template>
  <input-base
      ref="base"
      :read-only="readOnly"
      :editor-mode="editorMode"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
  >
    <template slot="readOnly">
      <div v-html="formattedValue"></div>
    </template>

    <template slot="editor">
      <div class="form-control grey-label readonly-input">
        <div v-html="formattedValue"></div>
      </div>
      <b-button
          data-test-path="tree-select-button"
          class="form-button ml-1 d-none d-xl-inline-block"
          variant="plm-action"
          :disabled="readOnly"
          @click="changeParent"
      >
        <font-awesome-icon icon="pencil-alt" class="mr-2"/>
        {{$tr("select","Select")}}
      </b-button>
      <b-button
          class="form-button-icon ml-1 d-xl-none"
          variant="plm-action"
          :disabled="readOnly"
          @click="changeParent"
      >
        <font-awesome-icon icon="pencil-alt" class="mr-2"/>
      </b-button>
    </template>

        <template slot="label-links">
          <!--    TODO moze kiedys z tym wrocimy, na razie usuwamy - wprowadza zbyt wiele bledow w systemie, dzialanie tych przyciskow jest niepoprawnie obsluzone-->
          <!--          <span v-if="true" class="pl-0">-->
          <!--            <b-link v-if="true" @click="edit()" class="px-0 pr-2 pl-1" style="position: absolute; height: 16px;">-->
          <!--                <font-awesome-icon icon="pencil-alt" transform="shrink-4"></font-awesome-icon>-->
          <!--            </b-link>-->
          <!--          </span>-->
        </template>

  </input-base>

</template>

<script>

import SelectFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig";
import FormsLoader from "@/components/forms/FormsLoader";
import FormsActions from "@/components/forms/FormsActions";
import FormsAI from "@/components/forms/FormsAI";
import InputBase from "@/components/inputs/InputBase";
import FormValidatedField from "@/components/forms/FormValidatedField";
import ShowTreeRootOptions from "@/server/com/silkplm/engine/forms/schema/ShowTreeRootOptions";

export default {
  name: "TreeSelectActivityRenderer",
  components: {InputBase},
  beforeMount() {

  },

  async mounted(){
    this.validatedField.onParentFkChange = async (newKey) => {
      let inst = await this.validatedField.getForeignInstance();
      if(inst && inst[this.validatedField.formFieldConfig.filteringFieldByParent] === newKey){
        return;
      }

      this.validatedField.value = null;
      this.valChange(null);
    }
    this.valChange(this.validatedField?.value);
    this.foreignForm = FormsLoader.detectFormConfig(this.fieldConfig.foreignClass, true);
    this.addEnabled = this.foreignForm.writePermitted && this.foreignForm.addFromForeignSelect;
    this.editEnabled = this.foreignForm.writePermitted && this.validatedField?.value && this.foreignForm.editFromForeignSelect;
  },

  props:{
    validatedField: { type: FormValidatedField, required:true },
    fieldConfig: { type: SelectFormFieldConfig, required:true },
    context: {default: null},
    openFromGrid: {default: false},
    gridEditor: {default: null},
  },
  watch: {
    'validatedField': function (val){
      this.valChange(val.value);
    },
    'validatedField.value': function (val){
      this.valChange(val);
    },
    'format': function (val){
      this.valChange(val);
    },
  },
  methods:{

    valChange(val){
      const field = this.validatedField?.foreignValueLabel;
      if(val == null){
        this.formattedValue = "";
        return;
      }

      let treeForm = FormsLoader.detectFormConfig(this.validatedField.getForeignClass());
      /** @type {TreeConfig} */
      let treeConfig = treeForm.extendedConfigs.TreeConfig;

      if(field == null || treeConfig?.useLongNames){
        if(treeConfig?.useLongNames){
          this.validatedField?.getTreePath().then(res => {
            if(!res?.pathLabels){
              this.formattedValue = '';
            } else {
              if(treeConfig.whenShowRoot === ShowTreeRootOptions.ALWAYS) {
                this.formattedValue = res.pathLabels.join("/");
              } else if(treeConfig.whenShowRoot === ShowTreeRootOptions.NEVER) {
                if(res.pathLabels.length > 1){
                  this.formattedValue = res.pathLabels.slice(1).join("/");
                } else {
                  this.formattedValue = "";
                }
              } else { // IF_ROOT_ONLY
                if(res.pathLabels.length > 1){
                  this.formattedValue = res.pathLabels.slice(1).join("/");
                } else {
                  this.formattedValue = res.pathLabels.join("/");
                }
              }
            }
          });
        } else {
          this.validatedField?.getForeignLabel().then(res => this.formattedValue = res);
        }
      } else {
        this.formattedValue = field;
      }
    },

    async changeParent() {
      if(this.$parent.$options.name === "GridCellEditor"){
        this.$parent.close();
      }
      // add dynamic
      let filter = null;
      if(this.fieldConfig.hasFilter || this.fieldConfig.hasContextFilter){
        this.validatedField.validatedForm.collectInputs?.();
        filter = {
          instance: this.validatedField.validatedForm.originalSource,
          fieldName: this.validatedField.formFieldConfig.fieldName
        }
      }

      // add title
      let activity = await FormsActions.showSelectListWithParentId(
          this.fieldConfig.foreignClass,
          this.validatedField,
          {filter, context: this.context, parentFk:this.validatedField.getParentFkKey()});

      /** @type {} */
      let result = await activity.getResult();
      if (result === null) {
        this.validatedField.value = null;
        this.valChange(null);
        if (this.$parent.$options.name === "GridCellEditor") {
          await this.$parent.saveAndClose();
        }
      } else if (result !== undefined) {
        const title = FormsAI.getEntityLabel(FormsLoader.detectFormConfig(this.fieldConfig.foreignClass), result);
        this.validatedField.foreignValueLabel = title;
        this.validatedField.foreignValueInstance = result;
        this.validatedField.value = result.id;
        this.formattedValue = title;
        if(this.$parent.$options.name === "GridCellEditor") {
          await this.$parent.saveAndClose();
        }
      }
    },

    setReadOnly(readOnly){
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    setEditorMode(val){
      this.editorMode = val;
    },

    async edit(){
      if(this.foreignForm && this.validatedField.value){
        let entity = await Rpc.Forms.getEntity(this.foreignForm.formClassLong, this.validatedField.value)
        await FormsActions.edit(entity);
      }
    },
  },

  data: () => ({
    options: [],
    idToLabel: new Map(),
    readOnly: true,
    editorMode: false,

    loadInProgress: false,
    currentOpt: {},
    valueSetFromList: false,
    valueSetFromCurrent: false,
    nullAdded: false,
    listLoaded: false,
    optionsList: [],
    nullRow: {value:null, text:''},
    formattedValue: "",
    foreignForm: null,
    addEnabled: false,
    editEnabled: false,
  })
}
</script>

<style scoped>

</style>